<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Medical Exam Certificate</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <medical-exam-certificate [customerNumberId]="data.customerNumberId"
                              [reportId]="data.reportId"
                              [createNewReport]="data.createNewReport"
                              [isReadOnly]="data.isReadOnly"
                              [businessTransactionNumberId]="data.businessTransactionId"
                              (formValidity)="formValidationStatus($event)"
                              (closeOuterModal)="close()"
                              (isSaving)="isSaving($event)"
                              [dialogRef]="dialogRef">
    </medical-exam-certificate>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="close()">Cancel</button>
        <mvm-spinner-btn [isLoading]="saving" btnText="Save" [isDisabled]="true != isFormValid || data.isReadOnly" (clicked)="save()"></mvm-spinner-btn>
    </div>
</div>